<template>
  <span>{{ displayValue }}</span>
</template>

<script>
export default {
  name: 'AnimatedNumber',
  props: {
    value: { type: Number, default: 0 },
    duration: { type: Number, default: 600 }
  },
  data() {
    return {
      displayValue: 0,
      startTime: null,
      startValue: 0
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.startValue = oldVal
      this.startTime = Date.now()
      this.animate()
    }
  },
  methods: {
    animate() {
      const elapsed = Date.now() - this.startTime
      const progress = Math.min(elapsed / this.duration, 1)

      // easeOutQuart
      const ease = 1 - Math.pow(1 - progress, 4)

      this.displayValue = Math.round(this.startValue + (this.value - this.startValue) * ease)

      if (progress < 1) {
        requestAnimationFrame(this.animate)
      }
    }
  }
}
</script>
